import {
  computed, ref,
} from '@vue/composition-api'
import _ from 'lodash'
import store from '@/store'
import { parseRequestError } from '@/helpers/helpers'
import useAttachment from '@/views/_global/useAttachment'

export default (__, { emit }) => {
  const meeting = computed(() => store.getters['calendar/getCalendarEvent'])
  const meetingId = meeting.value.id
  const processing = ref(true)
  const calendarEventCustomers = ref([])
  const showNoExerciseResultsAlert = computed(() => {
    if (processing.value) return false
    if (calendarEventCustomers.value.length === 0) return true
    return !calendarEventCustomers.value.some(calendarEventCustomer => calendarEventCustomer.exerciseResults.length > 0)
  })

  const timeouts = {}

  const {
    download,
  } = useAttachment(emit)

  const sort = data => _.orderBy(
    data,
    [
      item => item.customer.lastName,
      item => item.customer.firstName,
    ],
    'asc',
  )

  const fetchData = () => {
    processing.value = true
    store.dispatch('calendar/fetchCalendarEventPreviousExercises', meetingId)
      .then(res => {
        calendarEventCustomers.value = sort(res.data)
      })
      .catch(err => parseRequestError(err))
      .finally(() => {
        processing.value = false
      })
  }

  fetchData()

  const saveChanges = exerciseResult => {
    store.dispatch(
      'calendar/patchExerciseResult',
      {
        id: exerciseResult.id,
        data: {
          rating: exerciseResult.rating,
          comment: exerciseResult.comment,
        },
      },
    )
      .catch(err => parseRequestError(err))
  }

  const changeHandler = exerciseResult => {
    clearTimeout(timeouts[exerciseResult.id])
    timeouts[exerciseResult.id] = setTimeout(() => {
      saveChanges(exerciseResult)
    }, 2500)
  }

  return {
    processing,
    showNoExerciseResultsAlert,

    calendarEventCustomers,
    changeHandler,

    download,
  }
}
